import React from "react";
import "./DialogHost.css";
import { useDialog } from "../../contexts/DialogContext";

function DialogHost() {
    const { pending, handleConfirm, handleCancel, handleClose } = useDialog();

    if (!pending) {
        return null;
    }

    const isConfirmation = pending.variant === "confirmation";

    return (
        <div className="dialog-overlay" onClick={isConfirmation ? handleCancel : handleClose}>
            <div className="dialog-panel" onClick={(event) => event.stopPropagation()}>
                <div className="dialog-message">{pending.message}</div>
                <div className={`dialog-actions${isConfirmation ? "" : " dialog-actions-single"}`}>
                    {isConfirmation ? (
                        <>
                            <button className="dialog-btn dialog-btn-cancel" onClick={handleCancel}>
                                {pending.cancelLabel ?? "Anuluj"}
                            </button>
                            <button
                                className="dialog-btn dialog-btn-confirm"
                                style={pending.confirmColor ? { background: pending.confirmColor } : undefined}
                                onClick={handleConfirm}
                            >
                                {pending.confirmLabel ?? "Usuń"}
                            </button>
                        </>
                    ) : (
                        <button className="dialog-btn dialog-btn-info" onClick={handleClose}>
                            {pending.closeLabel ?? "OK"}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default DialogHost;